<template>
  <div v-if="analytics" class="gp-content">
    <table-tile-bar :view.sync="view" :refresh="refresh">
      <router-link class="level-item button add" :to="{ name: 'admin.analytics.index.create' }">
        <i class="fas fa-plus"></i>
        Create Admin Analytic
      </router-link>
      <analytics-filter-bar
        ref="filterBar"
        :filter.sync="filter"
        :digita.sync="digita"
        :categories="categories"
        :tags="tags"
        :actions="actions"
        :showDigitaSwitch="false">
      </analytics-filter-bar>
    </table-tile-bar>
    <analytics-table
      v-if="view === 'table'"
      class="scroll-vertical full-height"
      :analytics="filteredAnalytics"
      :admin="true"
      v-on:analytic-table-tag-click="$refs.filterBar.addTagFilter($event.tag)"
      v-on:analytic-table-cat-click="$refs.filterBar.addCatFilter($event.cat)"
      v-on:analytic-table-action-click="$refs.filterBar.addActionFilter($event.action)">
    </analytics-table>
    <analytic-tiles v-else :analytics="analytics.items" :type.sync="filterType">
    </analytic-tiles>
  </div>
</template>

<script>
import analyticsFilter from '@/mixins/analyticsFilter';
import TableTileBar from '@/components/TableTileBar.vue';
import AnalyticTiles from '@/components/analytics/AnalyticTiles.vue';
import AnalyticsTable from '@/components/analytics/AnalyticsTable.vue';
import AnalyticsFilterBar from '@/components/analytics/AnalyticsFilterBar.vue';

export default {
  name: 'AnalyticsAdmin',
  mixins: [analyticsFilter],
  components: {
    AnalyticsFilterBar,
    AnalyticTiles,
    TableTileBar,
    AnalyticsTable,
  },
  async mounted() {
    this.refresh();
  },
  watch: {
    // Watch for changes in query params and set the view to table if
    // the 'view' param is set
    // eslint-disable-next-line
    '$route.query'() {
      this.view = this.$route.query.v || 'tiles';
      this.filterType = this.$route.query.f || 'categories';
      this.filter = this.$route.query.fi || [];
      if (typeof this.filter === 'string') {
        this.filter = [this.filter];
      }
    },
  },
  data() {
    return {
      view: 'table',
      endpoint: 'admin/listAnalytics',
    };
  },
};
</script>

<style lang="scss" scoped>
.full-height {
  height: 100%;
}
</style>
